export enum EmailTemplate {
  REQUEST_NEEDS_TO_BE_ACTIONED = 'request-needs-to-be-actioned',
  LAST_LOOK_TAKEN_ON_FLEET = 'last-look-taken-on-fleet',
  LAST_LOOK = 'last-look',
  CABOTAGE_VIOLATION = 'cabotage-violation',
  OPERATOR_PURCHASE_OFFER_BID_SUBMITTED = 'operator-purchase-offer-bid-submitted',
  OPERATOR_PURCHASE_OFFER_CANCELLED = 'operator-purchase-offer-cancelled',
  OPERATOR_PURCHASE_OFFER_DECLINED = 'operator-purchase-offer-declined',
  OPERATOR_PURCHASE_OFFER_ACCEPTED = 'operator-purchase-offer-accepted',
  OPERATOR_PURCHASE_OFFER_CREATED = 'operator-purchase-offer-created',
  RATING_EXPIRATION = 'rating-expiration',
  AOC_EXPIRATION = 'aoc-expiration',
  AUDIT_EXPIRATION = 'audit-expiration',
  SYNC_ERROR = 'sync-error',
  CREATE_OPERATOR = 'create-operator',
  UPDATE_OPERATOR = 'update-operator',
  NEW_OP_USER_ACTIVATION_EMAIL = 'new-op-user-activation-email',
  INSURANCE_EXPIRATION = 'insurance-expiration',
  OPERATOR_APPROVAL_EXPIRATION = 'operator-approval-expiration',
  AIRCRAFT_REPORT = 'aircraft-report',
  QUOTE_RECEIVED = 'quote-received',
  VENDOR_AOC_EXPIRATION = 'vendor-aoc-expiration',
  VENDOR_AOC_EXPIRED = 'vendor-aoc-expired',
  VENDOR_SAFETY_EXPIRATION = 'vendor-safety-expiration',
  VENDOR_SAFETY_EXPIRED = 'vendor-safety-expired',
  COI_EXPIRATION = 'coi-expiration',
  COI_EXPIRED = 'coi-expired',
  UNCATEGORIZED = 'uncategorized',
}
